import { apiClient } from "shared/utils";
import { ResetPasswordResponse, ResetPasswordRequest } from "api/models";

export const postResetPassword = async (values: ResetPasswordRequest) => {
  const { data } = await apiClient.post<ResetPasswordResponse>("/user/password/reset", values);

  return data;
};
